module.exports = __webpack_public_path__ + "static/media/configcontrol.87d3e306.jpg";